"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Glyph = exports.SvgWrapper = exports.InlineSvg = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _excluded = ["size", "color", "onClick", "glyph"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var InlineSvg = _styledComponents["default"].svg.withConfig({
  displayName: "style__InlineSvg",
  componentId: "g0s9b9-0"
})(["position:absolute;top:0;right:0;bottom:0;left:0;height:100%;width:100%;color:inherit;fill:", ";"], function (props) {
  return props.color ? "".concat(props.color) : 'inherit';
});

exports.InlineSvg = InlineSvg;

var SvgWrapper = _styledComponents["default"].div.withConfig({
  displayName: "style__SvgWrapper",
  componentId: "g0s9b9-1"
})(["display:inline-block;flex:0 0 ", ";width:", ";height:", ";min-width:", ";min-height:", ";position:relative;color:inherit;cursor:pointer;transition:0.25s;", ""], function (props) {
  return props.size ? "".concat(props.size, "px") : '32px';
}, function (props) {
  return props.size ? "".concat(props.size, "px") : '32px';
}, function (props) {
  return props.size ? "".concat(props.size, "px") : '32px';
}, function (props) {
  return props.size ? "".concat(props.size, "px") : '32px';
}, function (props) {
  return props.size ? "".concat(props.size, "px") : '32px';
}, function (_ref) {
  var active = _ref.active;
  return active && "transform: rotate(180deg);";
});

exports.SvgWrapper = SvgWrapper;

var Glyph = function Glyph(_ref2) {
  var glyph = _ref2.glyph;

  switch (glyph) {
    case 'arrow_up':
      return /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }));

    case 'arrow_down':
      return /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M0 0h24v24H0V0z",
        fill: "none"
      }));

    case 'more_vert':
      return /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
      }));

    default:
      return /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }));
  }
};

exports.Glyph = Glyph;

var Icon = function Icon(_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 32 : _ref3$size,
      color = _ref3.color,
      onClick = _ref3.onClick,
      glyph = _ref3.glyph,
      props = _objectWithoutProperties(_ref3, _excluded);

  return /*#__PURE__*/_react["default"].createElement(SvgWrapper, _extends({
    size: size,
    className: "icon",
    onClick: onClick
  }, props), /*#__PURE__*/_react["default"].createElement(InlineSvg, {
    color: color,
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: "1.414",
    "aria-labelledby": "title",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fit: true,
    preserveAspectRatio: "xMidYMid meet",
    id: glyph
  }, /*#__PURE__*/_react["default"].createElement(Glyph, {
    glyph: glyph
  })));
};

var _default = Icon;
exports["default"] = _default;